/* eslint-disable no-nested-ternary */
import {
    Grid,
    GridProps,
    Text,
} from '@chakra-ui/react';
import { CartAddButtonWithCounter } from 'features';
import React from 'react';
import { Image } from 'shared';
// eslint-disable-next-line no-restricted-imports
import { Link } from 'shared/ui/Link';

type CartItemCardProps = {
    type: 'delivery' |'culinary-studio' | 'outdoor-bars' | 'sweet-shop' | 'cake-to-order',
    uid: string,
    portionIndex?: number,
    title: string,
    price?: number,
    pricePrefix?: string,
    image?: {
        url: string
    },
    currency?: {
        abbreviation: string
    },
    count: number
} & GridProps & React.RefAttributes<HTMLDivElement>

export const CartItemCard: React.FC<CartItemCardProps> = ({
    type,
    uid,
    portionIndex,
    title,
    price,
    pricePrefix,
    image,
    currency,
    ...props
}) => (
    <Grid
        {...props}
        gap="1rem"
    >
        <Grid
            templateColumns="1fr auto"
            gap="2rem"
        >
            <Link to={type === 'cake-to-order' ? `/sweet-shop/articles-to-order/${uid}` : type === 'sweet-shop' ? `/sweet-shop/articles/${uid}` : `/${type}/${uid}`}>
                <Grid
                    templateColumns="6rem 10fr"
                    gap="2rem"
                >
                    <Grid
                        aspectRatio="1 / 1"
                        objectFit="cover"
                    >
                        <Image
                            src={image?.url}
                            width="100%"
                            height="100%"
                            objectFit="cover"
                        />
                    </Grid>
                    <Grid height="fit-content">
                        <Text
                            fontSize="1.5rem"
                            fontWeight={900}
                        >
                            {pricePrefix}
                            {' '}
                            {price ? `${price.toLocaleString()} ${currency?.abbreviation}` : 'Цена не указана'}
                        </Text>
                        <Text fontSize="1.25rem">
                            {title}
                        </Text>
                    </Grid>
                </Grid>
            </Link>
            <Grid
                margin="auto 0 0 auto"
            >
                <CartAddButtonWithCounter
                    height="fit-content"
                    withClear
                    type={type}
                    uid={uid}
                    portionIndex={portionIndex}
                />
            </Grid>
        </Grid>
    </Grid>
);
